import { CommandDefinition } from '../../../concepts/commands/CommandDefinition';
import { Convention } from '../../../concepts/objects';
import { Physical } from '../../canvas/entities/Physical';

export interface SmartContainer extends Physical {

    getPhysicalsNaturallyOrdered(): Physical[];

    queryPipe(subject: Physical): CommandDefinition<[string, string]> | null;
}

export const SmartContainer = new Convention<SmartContainer>('SmartContainer');
